import { useCallback, useEffect, useState } from "react"
import { dataService } from "utils/dataService"
import { logger } from "utils/logger"

export const useIntakeQuestionsForInteraction = ({ interactionId }) => {
  const [questions, setQuestions] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const fetchQuestions = useCallback(async (id) => {
    if (!id) {
      setQuestions([])
      setLoading(false)
      return
    }
    setLoading(true)
    setError(null)
    try {
      const response = await dataService.IntakeQuestions.getForInteractionId({ interactionId: id })
      setQuestions(response?.data || [])
    } catch (err) {
      logger.error(`Failed to fetch intake questions for interaction ${id}`, err)
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchQuestions(interactionId)
  }, [interactionId, fetchQuestions])

  const refetch = useCallback(() => fetchQuestions(interactionId), [interactionId, fetchQuestions])

  return { questions, loading, error, refetch }
}
